import Auth from '@aws-amplify/auth';
import { call, takeLatest } from 'redux-saga/effects';

import { Types } from './../ducks';

export function* signOut() {
  return yield call([Auth, 'signOut']);
}

/* istanbul ignore next */
export function* watchForSignOut() {
  yield takeLatest(Types.SIGN_OUT, signOut);
}
